import { render, staticRenderFns } from "./chemGhs2.vue?vue&type=template&id=0a71be60"
import script from "./chemGhs2.vue?vue&type=script&lang=js"
export * from "./chemGhs2.vue?vue&type=script&lang=js"
import style0 from "./chemGhs2.vue?vue&type=style&index=0&id=0a71be60&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a71be60')) {
      api.createRecord('0a71be60', component.options)
    } else {
      api.reload('0a71be60', component.options)
    }
    module.hot.accept("./chemGhs2.vue?vue&type=template&id=0a71be60", function () {
      api.rerender('0a71be60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/mam/chemGhs2.vue"
export default component.exports